<template>
  <el-dialog
    :visible.sync="showLocal"
    :width="dialogWidth"
    :title="$t('coach.leader.invitation.available')"
  >
    <div>
      <i18n path="coach.leader.invitation.contactUs">
        <template #email>
          <a href="mailto:support@globalcoachgroup.com">support@globalcoachgroup.com</a>
        </template>
      </i18n>
    </div>
    <div slot="footer">
      <div style="width: 100%; text-align: center;">
        <el-button
          type="primary"
          round
          style="margin: auto;"
          @click="showLocal = false"
        >
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'InvitationAvailableAlert',

  mixins: [dialog],
};
</script>
